import { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from 'types/entities/JwtPayload';

const PROVIDERS = ['google', 'apple'] as const;
type Provider = typeof PROVIDERS[number];

export default function useOAuthProviderInfo() {
  return useMemo(() => {
    const accessToken = localStorage.getItem('kubota_access_token');

    if (!accessToken) {
      return { isAuthenticatedUsingOAuth: false, provider: undefined };
    }

    try {
      const { idp } = jwtDecode<JwtPayload>(accessToken);

      const provider = getProvider(idp);
      const isAuthenticatedUsingOAuth = provider !== undefined;
      return { isAuthenticatedUsingOAuth, provider };
    } catch (error) {
      return { isAuthenticatedUsingOAuth: false, provider: undefined };
    }
  }, []);
}

const getProvider = (idp?: string): Provider | undefined => {
  if (!idp) return undefined;
  if (idp?.includes('google')) return 'google';
  if (idp?.includes('apple')) return 'apple';
};
